import { render } from "./LayersTwoDashedIcon.vue?vue&type=template&id=65d38db1"
import script from "./LayersTwoDashedIcon.vue?vue&type=script&lang=js"
export * from "./LayersTwoDashedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__